// src/services/attendanceService.js

import apiClient from "./apiClient";

const API_URL = `/attendance`; // Use relative path since apiClient has baseURL

// New functions for staff attendance
export const getTodaysAttendanceByStaffId = async (staff_id) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/today/staff/${staff_id}`);
  return response.data;
};

export const getAttendanceByStaffId = async (staff_id) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/staff/${staff_id}`);
  return response.data;
};

export const createAttendance = async (data) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(API_URL, data);
  return response.data;
};

export const getAllAttendance = async () => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(API_URL);
  return response.data; 
};

export const getAttendanceId = async (id) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/${id}`);
  return response.data;
};

export const updateAttendance = async (attendanceId, data) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.put(`${API_URL}/${attendanceId}`, data);
  return response.data;
};

export const deleteAttendance = async (id) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.delete(`${API_URL}/${id}`);
  return response.data;
};

export const getTodaysAttendanceByDoctorId = async (doctor_id) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/today/${doctor_id}`);
  return response.data;
};

export const getAttendanceByDoctorId = async (doctor_id) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/doctor/${doctor_id}`);
  return response.data;
};

export const getAttendanceByDate = async (date) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/by-date?date=${date}`);
  return response.data;
};

// New Leave APIs added here:

export const applyLeave = async (data) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(API_URL, data);
  return response.data;
};

export const getAllLeaves = async () => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(API_URL);
  return response.data;
};

export const getLeaveById = async (id) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/${id}`);
  return response.data;
};

export const updateLeave = async (id, data) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.put(`${API_URL}/${id}`, data);
  return response.data;
};

export const deleteLeave = async (id) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.delete(`${API_URL}/${id}`);
  return response.data;
};
